import { LocationId } from '../location';

export interface BaseLocationPublishParams {
    locationId: LocationId;
}

export const PUBLISH_API_ROOT = '/api/publish';
export const LOCATION_PATH_ELEMENT = '/location/:locationId';
